<template>
  <div class="h5-login">
    <div class="h5-login-box">
      <a-icon type="shop" style="font-size: 48px; color: #1890ff" />
      <h2>收单系统</h2>
      <p class="tip">{{ tip }}</p>
      <a-button type="primary" block size="large" :loading="loading" @click="startAuth">微信授权登录</a-button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getH5AuthorizeUrl, h5WxCallback } from '@/api/plugin/orderReceive'

export default {
  name: 'H5Login',
  data() {
    return {
      loading: false,
      tip: '请通过微信公众号授权登录，首次进入需由供应商分享邀请链接'
    }
  },
  mounted() {
    // 已登录直接进入订单页
    if (Vue.ls.get(ACCESS_TOKEN)) {
      this.$router.replace('/h5/orders')
      return
    }
    // 微信授权回调：URL 携带 code 时换取登录态
    const code = this.$route.query.code
    if (code) {
      this.loading = true
      this.tip = '正在登录…'
      h5WxCallback({ code, state: this.$route.query.state }).then(res => {
        if (res.success && res.data && res.data.accessToken) {
          Vue.ls.set(ACCESS_TOKEN, res.data.accessToken, 7 * 24 * 60 * 60 * 1000)
          this.$router.replace('/h5/orders')
        } else {
          this.tip = res.message || '登录失败，请重试'
          this.loading = false
        }
      }).catch(() => {
        this.tip = '登录失败，请重试'
        this.loading = false
      })
    }
  },
  methods: {
    /** 发起公众号网页授权（静默），回调地址为当前页面 */
    startAuth() {
      this.loading = true
      this.tip = '正在跳转微信授权…'
      getH5AuthorizeUrl({ redirectUri: window.location.href }).then(res => {
        if (res.success && res.data && res.data.authorizeUrl) {
          window.location.href = res.data.authorizeUrl
        } else {
          this.tip = res.message || '获取授权地址失败'
          this.loading = false
        }
      }).catch(() => {
        this.tip = '获取授权地址失败，请检查网络'
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.h5-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}
.h5-login-box {
  width: 80%;
  max-width: 320px;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  padding: 40px 24px;
}
.h5-login-box h2 {
  margin: 12px 0 8px;
}
.tip {
  color: #999;
  font-size: 13px;
  margin-bottom: 24px;
  word-break: break-all;
}
</style>
